import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
    addCountryTools,
    getCountries,
    setEditCountry,
    updateCountryTools
} from '../actions/toolsActions';
import CreateModalContainer from "../CreateModalContainer";
import AutoTable from "../../components/common/AutoTable";
import styled from "styled-components";
import MatBox from "../../components/common/Mat/MatBox";
import StyledIcon from "../../components/common/StyledIcon";
import MatButton from "../../components/common/Mat/MatButton";
import countriesTableModal from "../countriesTableModal";
import CountryModalContainer from "./CountryModalContainer";

function ToolsCountry({addCountryToolsData, updateCountryToolsData, getCountriesData, countryEdit, countries, setEditCountryData}) {
    const [showNameModal, setShowNameModal] = useState(false);
    const [countryName, setCountryName] = useState("");
    const [responsible, setResponsible] = useState("");
    const [responsibleId, setResponsibleId] = useState(null);

    useEffect(() => {
        getCountriesData();
    },[])

    useEffect(() => {
        if(countries.find(el => el._id == countryEdit)) {
            setCountryName(countries.find(el => el._id == countryEdit).title);
            setResponsible(countries.find(el => el._id == countryEdit).responsibleUser[0].displayName);

        }
    }, [countryEdit]);
    const updateCountryName = (value) => {
        setCountryName(value.toUpperCase());
    }
    const updateCountryResponsible = (value) => {
        setResponsible(value.label);
        setResponsibleId(value.value);
    }

    const ResultsBox = styled(MatBox)`
    padding: 0;
    padding-top: 25px;
    strong {
        margin: 15px;
        font-size: 17px;
    }
    `;

    return (
        <div>
            <ResultsBox>
                <strong>COUNTRIES {countryEdit}</strong>
                <MatButton success withIcon style={{float: "right", marginRight: 20}}
                           onClick={() => setShowNameModal(!showNameModal)}>
                    Add new country<StyledIcon glyph="plus" />
                </MatButton>
                <AutoTable
                    model={countriesTableModal}
                />
            </ResultsBox>
            <CountryModalContainer
                showNameModal={showNameModal}
                closeModal={() => setShowNameModal(false)}
                onSave={() => addCountryToolsData(countryName, responsibleId)}
                name={countryName}
                setName={updateCountryName}
                title="country"
                icon="flag"
                responsible={responsible}
                setResponsible={updateCountryResponsible}
            />
        {/*    modal for editing country */}
            <CountryModalContainer
                showNameModal={countryEdit}
                closeModal={() => setEditCountryData(null)}
                onSave={() => updateCountryToolsData(countryName, responsibleId)}
                name={countryName}
                setName={updateCountryName}
                title="country"
                icon="flag"
                responsible={responsible}
                setResponsible={updateCountryResponsible}
            />
        </div>
    );
}

const mapStateToProps = ({toolsReducer}) => {
    return {
        ...toolsReducer
    }
}

function mapDispatchToProps() {
    return dispatch => ({
        addCountryToolsData: (countryName, responsibleId) => dispatch(addCountryTools(countryName, responsibleId)),
        updateCountryToolsData: (countryName, responsibleId) => dispatch(updateCountryTools(countryName, responsibleId)),
        getCountriesData: () => dispatch(getCountries()),
        setEditCountryData: (value) => dispatch(setEditCountry(value))
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(ToolsCountry);
